var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM13.5805 7.97493C13.8428 7.65434 13.7955 7.18183 13.4749 6.91953C13.1543 6.65724 12.6818 6.70449 12.4195 7.02507L8.44432 11.8837L7.03033 10.4697C6.73744 10.1768 6.26256 10.1768 5.96967 10.4697C5.67678 10.7626 5.67678 11.2374 5.96967 11.5303L7.96967 13.5303C8.1195 13.6802 8.32573 13.7596 8.53736 13.7491C8.74899 13.7385 8.94629 13.6389 9.08047 13.4749L13.5805 7.97493Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheck);
export default __webpack_public_path__ + "static/media/orange-check.5cb32e2dbb89137a9b2e2e5f30abfef2.svg";
export { ForwardRef as ReactComponent };